import React, { useRef, useState, useEffect, Fragment } from "react";
import Layout from "components/layout/Layout";
import localization from "assets/localization/localization";
import callWebService, { callTypes } from "services/utils/networks/network";
import {
  checkEmpty,
  dateParser,
  statusToTextActiveInactive,
} from "services/utils/commonFunctions/CommonFunctions";
import Config from "services/config/config";
import { trim, uniq } from "lodash";
import CustomModal from "components/modal/modal";
import CopyPaste from "components/copypaste/Copypaste";
import { BaseUrl } from "context/baseUrl/baseUrl";
import FormSection from "components/form/FormSection";
import DropDownFilter from "components/input/dropdown/dropDownFilter";
import Loader from "components/loader/loader";
import  ConstVar from "constants/const";
import MainLayout from "components/mainLayout/MainLayout";
import JsonFormatter from "react-json-formatter";
import DropdownFilter from "components/input/dropdown/dropDownFilter";

const PartnerHistory = ({ match }) => {
  const [isCheck, setIsCheck] = useState([]);
  const [smallModal, setSmallModal] = useState({hover1: false, hover2: false, show: false});
  const [modalShow, setModalShow] = useState(false);
  const [activeComponent, setActiveComponent] = useState();
  const [isLoading, setisLoading] = useState(false);
  const [partnerCode, setPartnerCode] = useState("");
  const [partnerApplicationNo, setPartnerApplicationNo] = useState("");
  const [response, setResponse] = useState(null);
  const [request, setRequest] = useState({});
  const [pageNo, setPageNo] = useState(1);
  const [show, setShow] = useState(false);
  const [perPageRecord, setPerPageRecord] = useState(10);
  const [totalRecord, setTotalRecord] = useState(0);
  const [breList, setBreList] = useState([]);
  const scrl = useRef(null);

  useEffect(()=>{
    (async () => {
    breApi(1);
   })();
  },[])

  const breApi = async (page, handleRecordPerPage) => {
    setisLoading(true);
    const id=match?.params?.id;
    const data={
      pageSize: handleRecordPerPage ? handleRecordPerPage : perPageRecord,
      pageNo: page ? page : 1,
      partnerId: id    
    }

    const res = await callWebService(
      callTypes.post,
      data,
      Config.partnerHistory
    );

    if (res?.data?.data?.partnerHistoryList) {
      setBreList(res?.data?.data?.partnerHistoryList);
      setPerPageRecord(res?.data?.data?.pagination?.pre_page_records);
      setTotalRecord(res?.data?.data?.pagination?.total_rows);
      setPageNo(page ? page : res?.data?.data?.pagination?.current_page);
      setisLoading(false);
    }
  }

  const renderHeader = () => {
    let headerElement = [
      "S.No.",
      "User Name",
      "Action Details",
      "Action Date",
      "Action Time",
      "Remarks",
    ];

    return headerElement.map((key, index) => {
      return <th key={index}>{key}</th>;
    });
  };

  const partnerHistoryOldData = (data) => {
    setModalShow(true);
    if (data?.old_data) {
      const req = trim(
        typeof data?.old_data === "object"
          ? JSON.stringify(data?.old_data)
          : data?.old_data
      );
      setRequest(req);
    }
  };

  const closeModal = () => {
    setModalShow(false);
    setResponse("");
    setRequest("");
  };

  const testJSON = (text) => {
    if (typeof text !== "string") {
      return false;
    }
    try {
      var json = JSON.parse(text);
      return json;
    } catch (error) {
      return false;
    }
  };

  const jsonStyle = {
    propertyStyle: { color: "red" },
    stringStyle: { color: "green" },
    numberStyle: { color: "darkorange" },
  };

  const getBreMsg = (data) => {
    if (data?.success) {
      return data?.success?.toString();
    } else {
      return "na";
    }
  };
  const recordsPerPage = [
    { records_id: 10, records_value: 10 },
    { records_id: 20, records_value: 20 },
    { records_id: 30, records_value: 30 },
    { records_id: 50, records_value: 50 },
  ];

  const renderBody = () => {
    return (
      !checkEmpty(breList) &&
      breList.map((val, index) => {
        return (
          <tr key={index}>
            <td>{pageNo === 1 ? index + 1 : (pageNo - 1) * perPageRecord + index + 1 }</td>       
            <td>{val.action_by}</td>
            <td>
              {" "}
              <a
                style={{ cursor: "pointer" }}
                className="anchorNew"
                onClick={() => partnerHistoryOldData(val)}
              >
                <u>History</u>
              </a>
            </td>
            <td>
              {val.created_at ? dateParser(val.created_at, "MM-DD-YYYY") : null}
            </td>
            <td>
              {val.updated_at ? dateParser(val.updated_at, `${ConstVar.TIME_FORMAT}`) : null}
            </td>
             <td>{val.remarks}</td>
          </tr>
        );
      })
    );
  };

  const nextPage = async (page) => {
    setisLoading(true);
    breApi(page);
    setisLoading(false);
  }

  const handleRecordsPerPage = async (event) => {
    setPageNo(1);
    setisLoading(true);
    breApi(1, parseInt(event.target.value));
  };

  const searchDocuent = () => {
    setPageNo(1);
    breApi(1);
  }

  const resetDocument = () => {
    window.location.reload();
  }

  const inputSearch = () => {
    return (
      <>
        <div style={{ float: "right", position: "relative" }}>
          {breList && breList.length > 0 ? (
            <b
              className="pagination-value"
              data-hovered={smallModal.hover1}
              style={{ cursor: "pointer" }}
              onMouseLeave={() => {
                setSmallModal({ ...smallModal, hover1: false, hover2: false });
              }}
              onMouseEnter={() => {
                setSmallModal({ ...smallModal, hover1: true, show: true });
              }}
            >
              {pageNo == 1 ? pageNo : (pageNo - 1) * perPageRecord + 1}-
              {pageNo * perPageRecord > totalRecord
                ? totalRecord
                : pageNo * perPageRecord}{" "}
              of {totalRecord}
            </b>
          ) : (
            <span className="pagination-value">0 - 0 of 0</span>
          )}
          &nbsp;
          {smallModal.hover1 && (
            <div
              className="small-modal"
              onMouseEnter={() => {
                setSmallModal({ ...smallModal, hover2: true });
              }}
              onMouseLeave={() => {
                setSmallModal({ ...smallModal, hover2: false, hover1: false });
              }}
            >
              <span
                className="small-modal-option"
                data-disabled={pageNo === 1 && true}
                onClick={() => {
                  nextPage(1);
                }}
              >
                Newest
              </span>
              <span
                className="small-modal-option"
                data-disabled={totalRecord <= pageNo * perPageRecord && true}
                onClick={() => {
                  nextPage(Math.ceil(totalRecord / perPageRecord));
                }}
              >
                Oldest
              </span>
            </div>
          )}
          <button
            className="btn btn-warning btn-xs pagination-button"
            onClick={() => nextPage(pageNo - 1)}
            title="Newer"
            data-disabled={pageNo <= 1 && true}
            disabled={pageNo <= 1}
          >
            {"<"}
          </button>
          &nbsp;
          <button
            className="btn btn-warning btn-xs pagination-button"
            onClick={() => nextPage(pageNo + 1)}
            title="Older"
            data-disabled={
              totalRecord <= pageNo * perPageRecord || breList.length === 0
            }
            disabled={
              totalRecord <= pageNo * perPageRecord || breList.length === 0
            }
          >
            {">"}
          </button>
        </div>
        &nbsp;&nbsp;
      </>
    );
  };
  const filterSearch = () => {};

  return (
    <BaseUrl.Provider value={{ baseUrl: match.url }}>
      <MainLayout activeComponent={activeComponent} match={match}>
        <Layout
          title="Partner History"
          isLoading={false}
          isGoback={true}
          className={"desktop-view"}
        >
          <FormSection
            search={true}
            inputSearch={inputSearch}
            filterSearch={filterSearch}
            sortBy={() => {}}
            isCheck={isCheck}
          >
            <div
              className="panel-card-table"
              ref={scrl}
              style={{ width: "100%", overflow: "auto" }}
            >
              <table id="employee" className="table table-bordered">
                <thead>
                  <tr>{renderHeader()}</tr>
                </thead>
                <tbody>{renderBody()}</tbody>
              </table>
            </div>
            <div style={{maxWidth: '150px'}}>
              <DropdownFilter o
                  ptIdKey="records_id"
                  optValueKey="records_value"
                  optionList={recordsPerPage}
                  placeholder="Records Per Page"
                  onChange={(event) => {
                    setPerPageRecord(event.target.value);
                    handleRecordsPerPage(event);
                  }}
                  value={perPageRecord}
               />
            </div>
          </FormSection>
          {modalShow && (
            <CustomModal
              show={modalShow}
              modalClose={closeModal}
              showHeader
              backdrop
              
            >
              <div className="modal-body chekdisplay">
                <div
                  className="panel-card" style={{width: "100%"}}
                >
                  <div className="panel-heading pop">
                    <>
                        History
                        <div style={{ float: "right" }}>
                          <CopyPaste data={request} />
                        </div>
                    </>
                  </div>
                  <div className="panel-body  mx-0 pop ">
                    <div className="panel-card-table ">
                      <div className="popupclass">
                        {testJSON(
                          request
                            ? request.toString().replace(/\\/g, "")
                            : "null"
                        ) ? (
                          <JsonFormatter
                            json={
                              request
                                ? request.toString().replace(/\\/g, "")
                                : "null"
                            }
                            tabWith={4}
                            jsonStyle={jsonStyle}
                          />
                        ) : request ? (
                          request.toString().replace(/\\/g, "")
                        ) : (
                          "null"
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </CustomModal>
          )}
          <Loader isLoading={isLoading} />
        </Layout>
      </MainLayout>
    </BaseUrl.Provider>
  );
};

export default PartnerHistory;
